import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

const deleteGroupCard = EntityCardBlueprint.make({
  name: 'delete-group',
  params: {
    filter: 'kind:group',
    loader: async () => {
      const { DeleteGroupCard } = await import('./components/DeleteGroupCard');
      return compatWrapper(React.createElement(DeleteGroupCard));
    },
  },
});

export const groupActionsPlugin = createFrontendPlugin({
  pluginId: 'group-actions',
  extensions: [deleteGroupCard],
});
